import { Box } from "@chakra-ui/react";
import { useResponsive, VStack } from "goi_common";
import { ReactNode } from "react";

export default function SeaBurialTitleSection({
  district,
  description,
}: {
  district?: string;
  description: ReactNode;
}) {
  const { isBiggerThanMd } = useResponsive();
  return (
    <VStack padding={isBiggerThanMd ? "0" : "0px 24px"}>
      <Box as="h1" className="subtitle_21_b" wordBreak="keep-all">
        {district ? `${district} ` : ""}바다장례 비용 알아보기
      </Box>
      <Box as="h2" className="subtitle_16_b gray500" wordBreak="keep-all">
        {description}
      </Box>
    </VStack>
  );
}
